"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateVenueRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class CreateVenueRequestDto {}
exports.CreateVenueRequestDto = CreateVenueRequestDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CreateVenueRequestDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], CreateVenueRequestDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'WGS84 latitude'
}), __metadata("design:type", Number)], CreateVenueRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'WGS84 longitude'
}), __metadata("design:type", Number)], CreateVenueRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CreateVenueRequestDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], CreateVenueRequestDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], CreateVenueRequestDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Overture Maps GERS place id when linking a source candidate (no prefix).'
}), __metadata("design:type", Object)], CreateVenueRequestDto.prototype, "overtureId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'OSM element id when linking a source candidate, e.g. node/123 (no osm: prefix).'
}), __metadata("design:type", Object)], CreateVenueRequestDto.prototype, "osmId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport NE latitude; computed from point when omitted.'
}), __metadata("design:type", Number)], CreateVenueRequestDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport NE longitude; computed from point when omitted.'
}), __metadata("design:type", Number)], CreateVenueRequestDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport SW latitude; computed from point when omitted.'
}), __metadata("design:type", Number)], CreateVenueRequestDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport SW longitude; computed from point when omitted.'
}), __metadata("design:type", Number)], CreateVenueRequestDto.prototype, "southwestLongitude", void 0);
//# sourceMappingURL=CreateVenueRequest.dto.js.map